import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommercePaymentMethodsAction from '../actions/ecommerce-payment-methods.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommercePaymentMethods} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";

@Injectable()
export class EcommercePaymentMethodsEffect {

  loadEcommercePaymentMethods = createEffect(() => this._actions$.pipe(
    ofType(EcommercePaymentMethodsAction.LOAD_ECOMMERCE_PAYMENT_METHODS),
    mergeMap((action: LoadEcommercePaymentMethods) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getPaymentMethods(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data?.dataKey) {
              return new EcommercePaymentMethodsAction.LoadEcommercePaymentMethodsSuccess({
                data: this._orderPaymentMethods(response?.data?.dataKey),
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePaymentMethodsAction.LoadEcommercePaymentMethodsFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

  private _orderPaymentMethods(dataKey) {
    const reorderedArray = dataKey
      .sort((a, b) => {
        // Prioritize 'tenweb_payments_stripe' as the first element
        if (a.id === 'tenweb_payments_stripe') return -1;
        if (b.id === 'tenweb_payments_stripe') return 1;

        // Sort by existing order values, and assign numbers to empty orders
        if (a.order === "" && b.order === "") return 0;
        if (a.order === "") return 1;
        if (b.order === "") return -1;

        return a.order - b.order;
      })
      .map((item, index) => {
        // Update the 'order' value during the mapping
        item.order = index + 1;
        return item;
      });

    return reorderedArray;

  }

}
